<script setup>
import {RadioGroup, RadioGroupLabel, RadioGroupOption} from '@headlessui/vue'
import {ref} from "vue";

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
    'modelValue': Object,
    'options': Array,
    'containerClasses': String,
})

const selectedOption = ref();

const setSelectedOption = (option) => {
    let originalObject = props.options.filter(object => _.isEqual(object, option));

    if (originalObject.length < 1)
        return;

    selectedOption.value = originalObject[0];
}

const updatedModelValue = (modelValue) => {
    setSelectedOption(modelValue);
    emit('update:modelValue',modelValue);
}

setSelectedOption(props.modelValue);

</script>
<template>
    <RadioGroup :model-value="selectedOption" @update:modelValue="updatedModelValue" class="mt-2">
        <RadioGroupLabel class="sr-only">{{ $t('Choose an option') }}</RadioGroupLabel>
        <div :class="containerClasses ? containerClasses : 'grid grid-cols-3 gap-3 sm:grid-cols-6'">
            <RadioGroupOption as="template" v-for="option in options" :key="option.name"
                              :value="option" :disabled="option.disabled"
                              v-slot="{ active, checked }">
                <div
                    :class="[!option.disabled ? 'cursor-pointer focus:outline-none' : 'opacity-25 cursor-not-allowed', active ? 'ring-2 ring-primary-500' : '', checked ? 'text-primary-500 font-bold ring-2 ring-primary-500 border-transparent' : 'bg-white border-gray-300 text-gray-900 hover:bg-gray-50', 'border rounded-md py-2 flex items-center justify-center text-sm font-medium sm:flex-1']">
                    <RadioGroupLabel as="span">
                        {{ $t(option.name) }}
                    </RadioGroupLabel>
                </div>
            </RadioGroupOption>
        </div>
    </RadioGroup>
</template>